var map = {
	".": "qmV2",
	"./": "qmV2",
	"./deploy": "EeeG",
	"./deploy.js": "EeeG",
	"./dev": "jMqK",
	"./dev.js": "jMqK",
	"./index": "qmV2",
	"./index.js": "qmV2",
	"./sit": "lIbV",
	"./sit.js": "lIbV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UYj4";


//////////////////
// WEBPACK FOOTER
// ./src/env ^.*$
// module id = UYj4
// module chunks = 9